<template>
  <div>
    <AdminPianificazioni />
  </div>
</template>

<script lang="ts">

import AdminPianificazioni from '@/components/AdminPianificazioni.vue';
import { Options, Vue } from 'vue-class-component';


@Options({
  components: {
    AdminPianificazioni,
  },
})
export default class HomeView extends Vue {}
</script>
